import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWorldhealthorganizationComponent } from './simple-icons-worldhealthorganization.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWorldhealthorganizationComponent ],
    exports:      [ SimpleIconsWorldhealthorganizationComponent ],
    bootstrap:    []
})
export class SimpleIconsWorldhealthorganizationModule {}
